import { motion } from "framer-motion";
import { Compass, Target } from "lucide-react";
import mission_bg from "../../assets/images/about_mission.jpg";
export default function AboutVision() {
  return (
    <section className="relative w-full lg:py-24 md:py-16 py-10 bg-[#eeeeee] text-slate-900 overflow-hidden select-none">
     <div
        className="pointer-events-none absolute top-0 left-0 w-full h-full opacity-20 "
        style={{
          background:
            "linear-gradient(135deg, #62d4f7 0%, #5dc9f0 40%, #3579be 60%",
        }}
      />
      <div className="mx-auto 3xl:w-4/5 xl:w-[90%] px-6 lg:px-12 relative z-10">
        {/* Centered Editorial Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-24">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5   backdrop-blur-md shadow-xs mb-4">
            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-700">
              Core Purpose
            </span>
          </div>

          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-[#000036]">
            Vision &amp;{" "}
            <span className="font-serif italic font-light text-slate-500">
              Mission.
            </span>
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6  items-stretch">
          <div className="lg:col-span-7 flex flex-col justify-between gap-6">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="p-8 rounded-xl bg-[#ffffff] border border-slate-300/80 backdrop-blur-xl shadow-[0_15px_35px_rgba(0,0,0,0.03)] flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between pb-4 mb-5 border-b border-slate-200/80">
                  <div className="flex items-center gap-2.5">
                    <div className="h-10 w-10 rounded-xl bg-white border border-slate-300 text-[#000036] flex items-center justify-center shadow-xs">
                      <Target size={24} />
                    </div>
                    <h3 className="font-display text-base font-bold text-[#000036] tracking-tight">
                      Our Mission
                    </h3>
                  </div>
                </div>
                <p className="text-base text-slate-600 font-normal leading-relaxed">
                  Our mission is to empower organizations to modernize,
                  automate, and scale their business processes by delivering
                  end-to-end solutions across leading platforms like Pega,
                  ServiceNow, and Camunda.
                  <strong className="text-[#000036] font-semibold">Pega</strong>
                  ,{" "}
                  <strong className="text-[#000036] font-semibold">
                    ServiceNow
                  </strong>
                  , and{" "}
                  <strong className="text-[#000036] font-semibold">
                    Camunda
                  </strong>
                  .
                </p>
              </div>
              <div className="mt-6 pt-4 border-t border-slate-200/80 flex items-center justify-between text-sm  text-slate-500">
                <span>TARGET STANDARD</span>
                <span className="font-bold  uppercase">FORTUNE 500 READY</span>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="p-8 rounded-xl bg-[#000036] border border-slate-300/80 backdrop-blur-xl shadow-[0_15px_35px_rgba(0,0,0,0.03)] flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between pb-4 mb-5 border-b border-slate-100/50">
                  <div className="flex items-center gap-2.5">
                    <div className="h-10 w-10 rounded-xl bg-white border border-slate-300 text-[#000036] flex items-center justify-center shadow-xs">
                      <Compass size={24} />
                    </div>
                    <h3 className="font-display text-base font-bold text-white tracking-tight">
                      Our Vision
                    </h3>
                  </div>
                </div>
                <p className="text-base text-white font-normal leading-relaxed">
                  We aim to Innovate digital transformations for business by
                  optimizing business processes, solving complex problems,
                  enhancing productivity and efficiency and delivering promising
                  results to become the globally trusted partner for fortune 500
                  companies.{" "}
                </p>
              </div>

              <div className="mt-6 pt-4 border-t border-slate-100/50 flex items-center justify-between text-sm text-white">
                <span>TARGET STANDARD</span>
                <span className="font-bold text-white uppercase">
                  FORTUNE 500 READY
                </span>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-5 relative flex">
            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="relative w-full h-[520px] lg:h-full min-h-[480px] rounded-xl overflow-hidden bg-[#000036] shadow-[0_25px_60px_rgba(0,0,0,0.08)] border border-black/10 flex flex-col justify-between p-8 sm:p-8"
            >
              <img
                src={mission_bg}
                alt="Intelligent Systems Architecture"
                className="absolute inset-0 h-full w-full object-cover grayscale-[15%] contrast-110 opacity-70"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#000036] via-[#000036]/10 to-[#000036]/20" />
              <div className="relative z-10 flex items-center justify-between"></div>
              <div className="relative z-10 p-4 rounded-xl bg-[#000036] backdrop-blur-xl  shadow-md">
                <h4 className="font-display text-base font-bold text-white leading-snug">
                  Autonomous Intelligence for High-Throughput Workflows
                </h4>
                <p className="mt-1 text-sm text-white font-normal leading-relaxed">
                  Orchestrating mission-critical multi-tiered operations with
                  certified fault tolerance and continuous delivery.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
